import React from 'react'

function Account() {
    return (
        <div>
            The account page section is currently in development. coming soon...
        </div>
    )
}

export default Account
